import { useGetStrings } from "@app/store/service/cmsService"
import { Modal, useModal } from "@tecreation/funnel-components"

import { MultilineText } from "@app/components/core/MultilineText/MultilineText"
import Button from "@app/components/move2Library/Button/Button"
import "./LoungerGuaranteedModal.css"

export default function LoungerGuaranteedModal() {
	const {
		data: { buttonClose, loungerGuaranteedTitle, loungerGuaranteedBody },
	} = useGetStrings()
	const { hideModal } = useModal()

	return (
		<Modal ariaLabelledBy="lounger-modal-title" ariaDescribedBy="lounger-modal-description">
			<Modal.Closer />
			<Modal.Header>
				<h2 id="lounger-modal-title" className="h-without-default-style">
					{loungerGuaranteedTitle}
				</h2>
			</Modal.Header>

			<Modal.Body className="loungerGuaranteedModal">
				<MultilineText id="lounger-modal-description">{loungerGuaranteedBody}</MultilineText>
			</Modal.Body>

			<Modal.Footer className="flex flex-center">
				<Button style="primary" onClick={hideModal}>
					{buttonClose}
				</Button>
			</Modal.Footer>
		</Modal>
	)
}
